/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_A_MultidayInputs */



/**
* | output |
* | --- |
* | "Between days, use **Reset Check-In** and run a fresh check-in the next morning. Use **Go Offline** if the venue has unreliable internet." |
*
* @param {Og_Faq_A_MultidayInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_a_multiday = /** @type {((inputs?: Og_Faq_A_MultidayInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_A_MultidayInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Entre les jours, utilisez **Réinitialiser le pointage** et effectuez un nouveau pointage le lendemain matin. Utilisez **Passer hors ligne** si le lieu a une connexion internet peu fiable.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Entre días, use **Reiniciar check-in** y realice un check-in nuevo a la mañana siguiente. Use **Modo sin conexión** si el recinto tiene internet poco fiable.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Entre os dias, use **Resetar Check-in** e faça um novo check-in na manhã seguinte. Use **Ficar offline** se o local tiver internet instável.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tra un giorno e l'altro, usa **Resetta Check-In** ed esegui un nuovo check-in la mattina successiva. Usa **Vai offline** se la sede ha una connessione internet inaffidabile.")
	return /** @type {LocalizedString} */ ("Between days, use **Reset Check-In** and run a fresh check-in the next morning. Use **Go Offline** if the venue has unreliable internet.")
});